import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

// Clean integer for whole prices, 2 decimals otherwise — matches the Stripe charge.
export function formatPrice(n) {
  const v = Number(n) || 0;
  return Number.isInteger(v) ? String(v) : v.toFixed(2);
}

// Total units across all sizes for a product.
export function totalInventory(p) {
  const si = (p && p.size_inventory) || {};
  return Object.values(si).reduce((n, v) => n + (Number(v) || 0), 0);
}

// Storefront stock status for a LIVE product (product-level / aggregate across
// sizes). A product is only "Sold out" when every size is at 0. Coming-soon
// products keep their own waitlist messaging elsewhere.
export function stockStatus(p) {
  if (!p || p.status !== "live") {
    return { label: null, tone: null, purchasable: false };
  }
  const inv = totalInventory(p);
  const thr = Number(p.low_stock_threshold ?? 5);
  if (inv <= 0) {
    return p.allow_backorder
      ? { label: "Backorder", tone: "warn", purchasable: true }
      : { label: "Sold out", tone: "out", purchasable: false };
  }
  if (inv <= thr) return { label: "Low stock", tone: "low", purchasable: true };
  return { label: null, tone: null, purchasable: true };
}

// Per-size stock status for a LIVE product — governs the selected size on the
// product page (Add to Bag gates on this).
export function sizeStockStatus(p, size) {
  if (!p || p.status !== "live" || !size) {
    return { label: null, tone: null, purchasable: false };
  }
  const qty = Number((p.size_inventory || {})[size] ?? 0);
  const thr = Number(p.low_stock_threshold ?? 5);
  if (qty <= 0) {
    return p.allow_backorder
      ? { label: "Backorder", tone: "warn", purchasable: true }
      : { label: "Sold out", tone: "out", purchasable: false };
  }
  if (qty <= thr) return { label: `Only ${qty} left`, tone: "low", purchasable: true };
  return { label: "In stock", tone: "ok", purchasable: true };
}
